import { RelatedProduct } from '@repo/user-types'
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

export const getTaxProducts = async ({
  api,
  config,
}: {
  api: AxiosInstance
  params?: void
  config?: Pick<AxiosRequestConfig, 'signal'>
}): Promise<AxiosResponse<RelatedProduct[]>> => {
  return api.get<RelatedProduct[]>('/products/tax', config)
}
